import './travel-information.scss';

class TravelInformation {
    constructor (element) {
        this.$travelinformation = element;
        this.$$stepContents = this.$travelinformation.querySelectorAll('[data-travel-information="step-content"]');
    }

    initialize () {
        if (this.$$stepContents.length > 0) {
            if (!window.mediaMatch[1024].matches) {
                this.$$stepContents.forEach((step) => {
                    if (step.clientHeight > 900) {
                        const $toggle = step.nextElementSibling;

                        if ($toggle) {
                            step.style.maxHeight = step.clientHeight + 'px';

                            step.classList.add('is--reduced');

                            $toggle.addEventListener('click', () => {
                                step.classList.remove('is--reduced');
                            });
                        }
                    }
                });
            }

            if (window.mediaMatch[1024].matches) {
                this.$$stepContents.forEach((step) => {
                    if (step.classList.contains('is--reduced')) {
                        step.classList.remove('is--reduced');
                    }
                });
            }
        }
    }
}

export { TravelInformation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $travelInformation = $context.querySelector('[data-travel-information="root"]');

        if ($travelInformation) {
            const travelInformation = new TravelInformation($travelInformation);
            travelInformation.initialize();
        }
    }
});
